import { ApiDescriptionProps } from "../_models/APIDescription";
import { MockModel } from "../_models/MockModel";

export const MOCK_DATA: MockModel = {
  healthcareid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/HealthcareService/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/HealthcareService/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-HealthcareService",
    path: [
      {
        id: 1,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 2,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 3,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 4,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  healthcare: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/HealthcareService",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/HealthcareService",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-HealthcareService",
    path: [],
    header: [
      {
        id: 5,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 6,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 7,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 8,
        label: "coverage-area",
        placeholder: "Enter coverage area",
        value: "", // Provide the initial value here
        info: "Location(s) service is intended for/available to.",
        infobold: "",
        chains: true,
        chipsname: ["address", "address-postalcode", "address-city", "address-state", "type", "organization.name"],
      },
      {
        id: 9,
        label: "endpoint",
        placeholder: "Enter endpoint",
        value: "", // Provide the initial value here
        info: "Technical endpoints providing access to electronic services operated for the healthcare service.",
        infobold: "",
        chains: true,
        chipsname: ["organization.name"],
      },
      {
        id: 10,
        label: "location",
        placeholder: "Enter location",
        value: "", // Provide the initial value here
        info: "The location of the Healthcare Service.",
        infobold: "",
        chains: true,
        chipsname: ["address", "address-postalcode", "address-city", "address-state", "type", "organization.name"],
      },
      {
        id: 1110,
        label: "name",
        placeholder: "Enter name",
        value: "", // Provide the initial value here
        info: "A portion of the healthcare service name.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1111,
        label: "Organization",
        placeholder: "Enter Organization",
        value: "", // Provide the initial value here
        info: "The organization that provides this Healthcare Service.",
        infobold: "",
        chains: true,
        chipsname: ["name", "address", "type", 'partof.name'],
      },
      {
        id: 11,
        label: "service-category",
        placeholder: "Enter service-category",
        value: "", // Provide the initial value here
        info: "Service Category of the Healthcare Service.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 12,
        label: "service-type",
        placeholder: "Enter service-type",
        value: "", // Provide the initial value here
        info: "The type of service provided by this healthcare service.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 13,
        label: "specialty",
        placeholder: "Enter specialty",
        value: "", // Provide the initial value here
        info: "The specialty of the service provided by this healthcare service.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },

  endpoint: {
    headerId: "test",
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Endpoint",
    codeurl:
      " https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Endpoint",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Endpoint",
    path: [],
    header: [
      {
        id: 14,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
      {
        id: 15,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 16,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 17,
        label: "organization",
        placeholder: "Enter organization",
        value: "",
        info: "Select Endpoints managed by the specified organization.",
        infobold: "",
        chains: true,
        chipsname: ["name", "address", "type", "partof.name"],
      },
    ],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
    ],
  },
  endpointid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Endpoint/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Endpoint/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Endpoint",
    path: [
      {
        id: 18,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 19,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 20,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 21,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  insurance: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/InsurancePlan",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/InsurancePlan",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-InsurancePlan",
    path: [],
    header: [
      {
        id: 22,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 23,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],
    queryParams: [
      {
        id: 24,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 25,
        label: "administered-by",
        placeholder: "Enter administered by",
        value: "", // Provide the initial value here
        info: "Select products that are administered by the specified organization.",
        infobold: "",
        chains: true,
        chipsname: ["name", "partof.name"],
      },
      {
        id: 1224,
        label: "identifier",
        placeholder: "Enter identifier",
        value: "", // Provide the initial value here
        info: "Select products with the specified identifier.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1234,
        label: "name",
        placeholder: "Enter name",
        value: "", // Provide the initial value here
        info: "Select products with the specified name.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 225,
        label: "owned-by",
        placeholder: "Enter owned-by",
        value: "", // Provide the initial value here
        info: "Select products that are owned by the specified organization.",
        infobold: "",
        chains: true,
        chipsname: ["name", "partof.name"],
      },
      {
        id: 27,
        label: "plan-type",
        placeholder: "Enter plan-type",
        value: "", // Provide the initial value here
        info: "Select plans of the specified type.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 28,
        label: "type",
        placeholder: "Enter type",
        value: "", // Provide the initial value here
        info: "Select insurance plans of the specified type.",
        infobold: "",
        chains: false,
        chipsname: [],
      }
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  insuranceid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/InsurancePlan/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/InsurancePlan/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-InsurancePlan",
    path: [
      {
        id: 30,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 31,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 32,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 33,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  location: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Location",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Location",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Location",
    path: [],
    header: [
      {
        id: 34,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 35,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 36,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 37,
        label: "address",
        placeholder: "Address",
        value: "",
        info: "Select Locations with the specified ",
        infobold: "address",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 38,
        label: "address-city",
        placeholder: "City",
        value: "",
        info: "Select Locations with the specified ",
        infobold: "address.city",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 39,
        label: "address-postalcode",
        placeholder: "Postalcode",
        value: "",
        info: "Select Locations with the specified ",
        infobold: "address.postalcode",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 40,
        label: "address-state",
        placeholder: "State",
        value: "",
        info: "Select Locations with the specified ",
        infobold: "address.state",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 41,
        label: "endpoint",
        placeholder: "Endpoint",
        value: "",
        info: "Select Locations with the specified endpoint.",
        infobold: "",
        chains: true,
        chipsname: ["organization.name"],
      },
      {
        id: 241,
        label: "organization",
        placeholder: "Enter organization",
        value: "",
        info: "Select Locations managed by the specified organization.",
        infobold: "",
        chains: true,
        chipsname: ["name", "address", "type", "partof.name"],
      },
      {
        id: 242,
        label: "partof",
        placeholder: "Enter partof",
        value: "",
        info: "Select Locations that are part of the specified location.",
        infobold: "",
        chains: true,
        chipsname: ["address", "type", "organization.name"],
      },
      {
        id: 366,
        label: "type",
        placeholder: "Enter type",
        value: "", // Provide the initial value here
        info: "Select Locations of the specified type.",
        infobold: "",
        chains: false,
        chipsname: [],
      }
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  locationid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Location/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Location/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Location",
    path: [
      {
        id: 42,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 43,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 44,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 45,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  network: {
    url: "https://api-sandbox.aaneelconnect.com/providerdirectory/Network",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/providerdirectory/Network",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Network",
    path: [],
    header: [
      {
        id: 46,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 47,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 48,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 49,
        label: "address",
        placeholder: "Address",
        value: "",
        info: "Select network with the specified address (matches any of the string elements of an address)",
        infobold: "address",
        chains: false,
        chipsname: [],
      },
      {
        id: 50,
        label: "coverage-area",
        placeholder: "coverage-area",
        value: "",
        info: "Select health insurance provider networks available in a region described by the specified location",
        infobold: "",
        chains: true,
        chipsname: ["address", "type", "organization.name"],
      },
      {
        id: 51,
        label: "endpoint",
        placeholder: "Enter endpoint",
        value: "", // Provide the initial value here
        info: "Select networks with the specified endpoint.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  networkid: {
    url: "https://api-sandbox.aaneelconnect.com/providerdirectory/Network/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/providerdirectory/Network/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Network",
    path: [
      {
        id: 52,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 53,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 54,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 55,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  organization: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Organization",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Organization",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Organization",
    path: [],
    header: [
      {
        id: 56,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 57,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 58,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 59,
        label: "address",
        placeholder: "Address",
        value: "",
        info: "Select organizations with the specified address",
        infobold: "",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 60,
        label: "address-city",
        placeholder: "City",
        value: "",
        info: "A city specified in an address ",
        infobold: "",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 260,
        label: "address-country",
        placeholder: "country",
        value: "",
        info: "A country specified in an address ",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 61,
        label: "address-postalcode",
        placeholder: "Postalcode",
        value: "",
        info: "A postal code specified in an address",
        infobold: "",
        chains: false,
        chipsname: ["organization.name"],
      },
      {
        id: 62,
        label: "address-state",
        placeholder: "State",
        value: "",
        info: "A state specified in an address",
        infobold: "",
        chains: false,
        chipsname: ["organization.name"],
      }, {
        id: 262,
        label: "address-use",
        placeholder: "use",
        value: "",
        info: "A use code specified in an address",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 63,
        label: "endpoint",
        placeholder: "Endpoint",
        value: "",
        info: "Select Organizations with the specified endpoint",
        infobold: "",
        chains: true,
        chipsname: ["organization.name"],
      }, {
        id: 362,
        label: "name",
        placeholder: "name",
        value: "",
        info: "Select Organizations with the specified name",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 64,
        label: "partof",
        placeholder: "partof",
        value: "",
        info: "Select Organizations that are part of the specified organization.",
        infobold: "",
        chains: true,
        chipsname: ["name", "address", "type"],
      },
      {
        id: 266,
        label: "type",
        placeholder: "Enter type",
        value: "", // Provide the initial value here
        info: "Select Organizations of the specified type.",
        infobold: "",
        chains: false,
        chipsname: [],
      }
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  organizationid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Organization/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Organization/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Organization",
    path: [
      {
        id: 65,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 66,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 67,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 68,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  list: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/List",
    codeurl: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/List",
    languageurl:
      "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
    path: [],
    header: [
      {
        id: 69,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
      {
        id: 70,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 71,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: ["organization.name"],
      }
    ],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
    ],
  },
  listid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/List/{id}",
    codeurl: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/List/id",
    languageurl:
      "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
    path: [
      {
        id: 73,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 74,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 75,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 76,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  substance: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/Substance",
    codeurl:
      " https://api-sandbox.aaneelconnect.com/cms/r4/formulary/Substance",
    languageurl: "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
    path: [],
    header: [
      {
        id: 77,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 78,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 79,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 80,
        label: "category",
        placeholder: "category",
        value: "",
        info: "The category of the substance",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 81,
        label: "code",
        placeholder: "code",
        value: "",
        info: "The code of the substance or ingredient",
        infobold: "",
        chains: false,
        chipsname: [],
      }
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  substanceid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/Substance/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/Substance/id",
    languageurl: "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
    path: [
      {
        id: 85,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 86,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 87,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 88,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  medicationknowledge: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/Medicationknowledge",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/Medicationknowledge",
    languageurl:
      "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
    path: [],
    header: [
      {
        id: 89,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 90,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 91,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Change Healthcare Payer ID. Please read API marketplace documentation page for required parameters.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 92,
        label: "Drug Name",
        placeholder: "Enter drug name",
        value: "", // Provide the initial value here
        info: "Access the descriptive name of a formulary drug.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 93,
        label: "Drug Plan",
        placeholder: "Enter drug plan",
        value: "", // Provide the initial value here
        info: "Access the drug plan id of a formulary drug.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 94,
        label: "Drug Tier",
        placeholder: "Enter drug tier",
        value: "", // Provide the initial value here
        info: "Access the drug tier id of a formulary drug.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 97,
        label: "Code",
        placeholder: "Enter code",
        value: "", // Provide the initial value here
        info: "Code that identifies this medication.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  medicationknowledgeid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/MedicationKnowledge/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/formulary/MedicationKnowledge/id",
    languageurl:
      "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
    path: [
      {
        id: 98,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 99,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 100,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 101,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  OrganizationAffiliation: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/OrganizationAffiliation",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/OrganizationAffiliation",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-OrganizationAffiliation",
    path: [],
    header: [
      {
        id: 102,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 103,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 104,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 106,
        label: "endpoint",
        placeholder: "Enter endpoint",
        value: "", // Provide the initial value here
        info: "Select OrganizationAffiliations with the specified endpoint.",
        infobold: "",
        chains: true,
        chipsname: ["organization.name"],
      },
      {
        id: 105,
        label: "location",
        placeholder: "Enter location",
        value: "", // Provide the initial value here
        info: "Select OrganizationAffiliations available at the specified location.",
        infobold: "",
        chains: true,
        chipsname: ["address", "address-postalcode", "address-city", "address-state", "type", "organization.name",
          "organization.address",
          "organization.partof.name",
          "organization.type"],
      },
      {
        id: 405,
        label: "network",
        placeholder: "Enter network",
        value: "", // Provide the initial value here
        info: "Select roles where the organization is a member of the specified health insurance provider network.",
        infobold: "",
        chains: true,
        chipsname: ["name", "partof.name"],
      },
      {
        id: 107,
        label: "participating-organization",
        placeholder: "Enter participating-organization",
        value: "", // Provide the initial value here
        info: "Select roles filled by the specified organization",
        infobold: "",
        chains: true,
        chipsname: ["address", "name", "type", "partof.name"],
      },
      {
        id: 407,
        label: "primary-organization",
        placeholder: "Enter primary-organization",
        value: "", // Provide the initial value here
        info: "Select roles offered by the specified organization.",
        infobold: "",
        chains: true,
        chipsname: ["address", "name", "type", "partof.name"],
      }, {
        id: 404,
        label: "role",
        placeholder: "Enter role",
        value: "", // Provide the initial value here
        info: "Select OrganizationAffiliations with the specified role.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 507,
        label: "service",
        placeholder: "Enter service",
        value: "", // Provide the initial value here
        info: "Select OrganizationAffiliations providing the specified service.",
        infobold: "",
        chains: true,
        chipsname: ["service-category", "organization.name", "location.name"],
      }, {
        id: 204,
        label: "specialty",
        placeholder: "Enter specialty",
        value: "", // Provide the initial value here
        info: "Select OrganizationAffiliations associated with the specified specialty.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  OrganizationAffiliationid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/OrganizationAffiliation/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/OrganizationAffiliation/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-OrganizationAffiliation",
    path: [
      {
        id: 108,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 109,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 110,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 111,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Practitioner: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Practitioner",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Practitioner",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Practitioner",
    path: [],
    header: [
      {
        id: 112,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 113,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 114,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 115,
        label: "family",
        placeholder: "Enter family",
        value: "", // Provide the initial value here
        info: "The practitioner's family name.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 116,
        label: "given",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "The practitioner's given name.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 117,
        label: "name",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "The practitioner's name.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Practitionerid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Practitioner/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/Practitioner/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Practitioner",
    path: [
      {
        id: 118,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 119,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 120,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 121,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  PractitionerRole: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/PractitionerRole",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/PractitionerRole",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-PractitionerRole",
    path: [],
    header: [
      {
        id: 122,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 123,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 124,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 125,
        label: "endpoint",
        placeholder: "Enter endpoint",
        value: "", // Provide the initial value here
        info: "Technical endpoints providing access to electronic services operated for the healthcare service.",
        infobold: "",
        chains: true,
        chipsname: ["organization.name"],
      },
      {
        id: 126,
        label: "location",
        placeholder: "Enter location",
        value: "", // Provide the initial value here
        info: "The location of the Healthcare Service.",
        infobold: "",
        chains: true,
        chipsname: ["address", "address-postalcode", "address-city", "address-state", "type", "organization.name",
          "organization.address",
          "organization.partof.name",
          "organization.type"],
      },
      {
        id: 127,
        label: "network",
        placeholder: "Enter network",
        value: "", // Provide the initial value here
        info: "Select roles where the practitioner is a member of the specified health insurance provider network.",
        infobold: "",
        chains: true,
        chipsname: ["name", "address", "type", "partof.name"],
      },
      {
        id: 128,
        label: "organization",
        placeholder: "Enter organization",
        value: "", // Provide the initial value here
        info: "Organization where the roles are available.",
        infobold: "",
        chains: true,
        chipsname: ["name", "address", "type", "partof.name"],
      },
      {
        id: 129,
        label: "practitioner",
        placeholder: "Enter practitioner",
        value: "", // Provide the initial value here
        info: "Practitioner that is able to provide the defined services for the organization.",
        infobold: "",
        chains: true,
        chipsname: ["name"],
      },
      {
        id: 224,
        label: "role",
        placeholder: "Enter role",
        value: "", // Provide the initial value here
        info: "The practitioner can perform this role at for the organization.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 728,
        label: "service",
        placeholder: "Enter service",
        value: "", // Provide the initial value here
        info: "The list of healthcare services that this worker provides for this role's Organization/Location(s).",
        infobold: "",
        chains: true,
        chipsname: ["service-category", "organization.name", "location.name"],
      }, {
        id: 254,
        label: "specialty",
        placeholder: "Enter specialty",
        value: "", // Provide the initial value here
        info: "The practitioner has this specialty at an organization.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "429",
        description: "Too many request",
        dotType: "unknown",
      },
      {
        statusCode: "401",
        description: "Unauthorized",
        dotType: "unknown",
      },
    ],
  },
  PractitionerRoleid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/PractitionerRole/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory/PractitionerRole/id",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-PractitionerRole",
    path: [
      {
        id: 130,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 131,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 132,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 133,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  AllergyIntolerance: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/AllergyIntolerance",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/AllergyIntolerance",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-allergyintolerance|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 337,
        label: "patient",
        placeholder: "patient",
        value: "", // Provide the initial value here
        info: "",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 437,
        label: "clinical-status",
        placeholder: "clinical-status",
        value: "", // Provide the initial value here
        info: "",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  AllergyIntoleranceid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/AllergyIntolerance/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/AllergyIntolerance/id",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-allergyintolerance|6.1.0",
    path: [
      {
        id: 493,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Logical id of this artifact.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 19,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 898,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 20,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 21,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "bad",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  CarePlan: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/CarePlan",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/CarePlan",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-careplan|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 888,
        label: "category",
        placeholder: "Enter category",
        value: "", // Provide the initial value here
        info: "Type of plan.",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 688,
        label: "date",
        placeholder: "Enter date",
        value: "", // Provide the initial value here
        info: "Time period plan covers.",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 488,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "Who the care plan is for.",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 388,
        label: "status",
        placeholder: "Enter status",
        value: "", // Provide the initial value here
        info: "draft | active | suspended | completed | entered-in-error | cancelled | unknown",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  CareTeam: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/CareTeam",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/CareTeam",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-careteam|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 337,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "patient.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 437,
        label: "status",
        placeholder: "Patient Status",
        value: "", // Provide the initial value here
        info: "patient Status.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Condition: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Condition",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Condition",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition-problems-health-concerns|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 828,
        label: "category",
        placeholder: "Enter category",
        value: "", // Provide the initial value here
        info: "The category of the condition",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 728,
        label: "clinical-status",
        placeholder: "Enter clinical-status",
        value: "", // Provide the initial value here
        info: "The clinical status of the condition",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 628,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "Who has the condition?",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 528,
        label: "onset-date",
        placeholder: "Enter onset-date",
        value: "", // Provide the initial value here
        info: "Date related onsets (dateTime and Period)",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 428,
        label: "code",
        placeholder: "Enter code",
        value: "", // Provide the initial value here
        info: "Code for the condition",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Coverage: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Coverage",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Coverage",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-coverage|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  ExplanationOfBenefit: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/ExplanationOfBenefit",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/ExplanationOfBenefit",
    languageurl:
      "http://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-ExplanationOfBenefit",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 237,
        label: "status",
        placeholder: "Enter status",
        value: "", // Provide the initial value here
        info: "Status of the instance",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 337,
        label: "provider",
        placeholder: "Enter provider",
        value: "", // Provide the initial value here
        info: "The name or alias of the provider",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 437,
        label: "service-date",
        placeholder: "Enter service-date",
        value: "", // Provide the initial value here
        info: "The service date for the EOB. It can be ?service-date=le2020-01-01 or ?service-date=ge2020-01-01 or a range ?service-date=ge2019-10-01&service-date=le2020-01-01.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 537,
        label: "type",
        placeholder: "Enter type",
        value: "", // Provide the initial value here
        info: "The category of claim, e.g. oral, pharmacy, vision, institutional, professional.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 637,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "The party to whom the professional services and/or products have been supplied or are being considered and for whom actual for forecast reimbursement is sought.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 737,
        label: "identifier",
        placeholder: "Enter identifier",
        value: "", // Provide the initial value here
        info: "An identifier for the target resource. This is used when there is no way to reference the other resource directly, either because the entity it represents is not available through a FHIR server, or because there is no way for the author of the resource to convert a known identifier to an actual location. There is no requirement that a Reference.identifier point to something that is actually exposed as a FHIR instance, but it SHALL point to a business concept that would be expected to be exposed as a FHIR instance, and that instance would need to be of a FHIR resource type allowed by the reference.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Goal: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Goal",
    codeurl: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Goal",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-goal|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 666,
        label: "lifecycle-status",
        placeholder: "Enter lifecycle-status",
        value: "", // Provide the initial value here
        info: "proposed | planned | accepted | active | on-hold | completed | cancelled | entered-in-error | rejected",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 766,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "Who this goal is intended for",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 566,
        label: "target-date",
        placeholder: "Enter target-date",
        value: "", // Provide the initial value here
        info: "Reach goal on or before",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Immunization: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Immunization",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Immunization",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-immunization|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 111,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "Patient",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 211,
        label: "date",
        placeholder: "Enter date",
        value: "", // Provide the initial value here
        info: "date",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 311,
        label: "status",
        placeholder: "Enter status",
        value: "", // Provide the initial value here
        info: "status",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  MedicationRequest: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/MedicationRequest",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/MedicationRequest",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-medicationrequest|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 321,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "Returns prescriptions for a specific patient",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 201,
        label: "intent",
        placeholder: "Enter intent",
        value: "", // Provide the initial value here
        info: "Returns prescriptions with different intents",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 301,
        label: "status",
        placeholder: "Enter status",
        value: "", // Provide the initial value here
        info: "Status of the prescription",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 401,
        label: "encounter",
        placeholder: "Enter encounter",
        value: "", // Provide the initial value here
        info: "Return prescriptions with this encounter identifier",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 501,
        label: "authoredon",
        placeholder: "Enter authoredon",
        value: "", // Provide the initial value here
        info: "Return prescriptions written on this date",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Observation: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Observation",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Observation",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-observation-lab|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Patient: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Patient",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Patient",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-patient|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 977,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 777,
        label: "_id",
        placeholder: "Enter _id",
        value: "", // Provide the initial value here
        info: "Logical id of this artifact",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 677,
        label: "birthdate",
        placeholder: "Enter birthdate",
        value: "", // Provide the initial value here
        info: "The patient's date of birth",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 577,
        label: "family",
        placeholder: "Enter family",
        value: "", // Provide the initial value here
        info: "A portion of the family name of the patient",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 477,
        label: "gender",
        placeholder: "Enter gender",
        value: "", // Provide the initial value here
        info: "Gender of the patient",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 377,
        label: "identifier",
        placeholder: "Enter identifier",
        value: "", // Provide the initial value here
        info: "A patient identifier",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      }, {
        id: 277,
        label: "name",
        placeholder: "Enter name",
        value: "", // Provide the initial value here
        info: "A server defined search that may match any of the string fields in the HumanName, including family, give, prefix, suffix, suffix, and/or text",
        infobold: "",
        chains: true,
        chipsname: ["multipleAnd", "multipleOr", "modifier", "comparator", "chain"],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Procedure: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Procedure",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Procedure",
    languageurl:
      "http://hl7.org/fhir/us/core/StructureDefinition/us-core-procedure|6.1.0",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 555,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 455,
        label: "patient",
        placeholder: "Enter patient",
        value: "", // Provide the initial value here
        info: "Patient",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 355,
        label: "date",
        placeholder: "Enter date",
        value: "", // Provide the initial value here
        info: "date",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 655,
        label: "status",
        placeholder: "Enter status",
        value: "", // Provide the initial value here
        info: "status",
        infobold: "",
        chains: false,
        chipsname: [],
      }, {
        id: 755,
        label: "code",
        placeholder: "Enter code",
        value: "", // Provide the initial value here
        info: "code",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  everything: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Patient/{PatientId}/$everything",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/patientaccess/Patient/{PatientId}/$everything",
    languageurl:
      "http://hl7.org/fhir/us/core/STU6.1/ImplementationGuide-hl7.fhir.us.core",
    path: [
      {
        id: 118,
        label: "PatientId",
        placeholder: "PatientId",
        value: "",
        info: "Patient Id.",
        infobold: "",
      },
    ],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 138,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Metadata: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/Metadata",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/Metadata",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [],
    header: [
      {
        id: 135,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 136,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],

    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Authorize: {
    url: "https://api-sandbox.aaneelconnect.com/AadSmartOnFhirProxy/authorize",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/AadSmartOnFhirProxy/authorize",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [],
    queryParams: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "", // Provide the initial value here
        info: "Select Payer ID.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "client_id",
        placeholder: "{client_id}",
        value: "{client_id}", // Provide the initial value here
        info: "The client_id from your registered application.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "redirect_uri",
        placeholder: "{redirect_uri}",
        value: "{redirect_uri}", // Provide the initial value here
        info: "The callback URL of your application. The user will be directed to this URL after authorizing your application.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "response_type",
        placeholder: "code",
        value: "code", // Provide the initial value here
        info: "Supported response type: code",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "scope",
        placeholder: "openid profile email phone offline_access",
        value: "openid profile email phone offline_access", // Provide the initial value here
        info: "FHIR Scope",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "state",
        placeholder: "{Unique string}",
        value: "{Unique string}", // Provide the initial value here
        info: "Recommended. A random string used to protect against request forgery attacks.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "code_challenge",
        placeholder: "{code challenge}",
        value: "{code challenge}", // Provide the initial value here
        info: "codechallenge = BASE64URL-ENCODE(SHA256(ASCII(codeverifier)))",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "code_challenge_method",
        placeholder: "S256",
        value: "S256", // Provide the initial value here
        info: "Supported code_challenge_method: S256",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 137,
        label: "response_mode",
        placeholder: "query",
        value: "query", // Provide the initial value here
        info: "Supported response_mode: query",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Token: {
    url: "https://api-sandbox.aaneelconnect.com/AadSmartOnFhirProxy/Token",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/AadSmartOnFhirProxy/Token",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [],
    header: [
      {
        id: 147,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "",
        info: "Select Payer ID.",
        infobold: "",
      },
      {
        id: 136,
        label: "Content-Type",
        placeholder: "application/x-www-form-urlencoded",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],
    info: [
      {
        id: 200,
        label: "grant_type",
        placeholder: "placeholder for grant_type",
        value: "", // Provide the initial value here
      }, {
        id: 201,
        label: "code",
        placeholder: "placeholder for code",
        value: "", // Provide the initial value here
      }, {
        id: 202,
        label: "redirect_uri",
        placeholder: "placeholder for redirect_uri",
        value: "", // Provide the initial value here
      }
    ],
    queryParams: [],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  RefreshToken: {
    url: "https://api-sandbox.aaneelconnect.com/AadSmartOnFhirProxy/Token",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/AadSmartOnFhirProxy/Token",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [],
    header: [
      {
        id: 137,
        label: "payer-id",
        placeholder: "Enter Id",
        value: "",
        info: "Select Payer ID.",
        infobold: "",
      },
      {
        id: 136,
        label: "Content-Type",
        placeholder: "application/x-www-form-urlencoded",
        value: "",
        info: "request HTTP header indicates which content types, expressed as request HTTP header indicates which content types, expressed as MIME types.",
        infobold: "",
      },
    ],
    info: [
      {
        id: 203,
        label: "grant_type",
        placeholder: "placeholder for grant_type",
        value: "", // Provide the initial value here
      }, {
        id: 204,
        label: "refresh_token",
        placeholder: "placeholder for refresh_token",
        value: "", // Provide the initial value here
      }
    ],
    queryParams: [],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Group: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/Group",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/Group",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [],
    header: [
      {
        id: 1238,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 1240,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 1239,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "Optional UUID for request tracing",
        infobold: "",
      },
    ],
    info: [
      {
        id: 203,
        label: "grant_type",
        placeholder: "placeholder for grant_type",
        value: "", // Provide the initial value here
      }, {
        id: 204,
        label: "refresh_token",
        placeholder: "placeholder for refresh_token",
        value: "", // Provide the initial value here
      }
    ],
    queryParams: [
      {
        id: 1242,
        label: "identifier",
        placeholder: "Enter identifier",
        value: "", // Provide the initial value here
        info: "Search by Group identifier, NPI",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1243,
        label: "characteristic",
        placeholder: "Enter characteristic",
        value: "", // Provide the initial value here
        info: "Search by Group characteristic code",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1244,
        label: "characteristic-value",
        placeholder: "Enter characteristic value",
        value: "", // Provide the initial value here
        info: "<characteristic>$<value>\n\nExample: pdexprovidergroup$9876543210",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1245,
        label: "actual",
        placeholder: "Enter Actual",
        value: "", // Provide the initial value here
        info: "Whether the Group is an actual group of members",
        infobold: "",
        chains: false,
        chipsname: [],
        type: "boolean",
      },
      {
        id: 1246,
        label: "code",
        placeholder: "Enter Code",
        value: "", // Provide the initial value here
        info: "Group type code",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1247,
        label: "exclude",
        placeholder: "Enter exclude",
        value: "", // Provide the initial value here
        info: "Exclude members matching characteristic",
        infobold: "",
        chains: false,
        chipsname: [],
        type: "boolean",
      },
      {
        id: 1248,
        label: "managing-entity",
        placeholder: "Enter managing entity",
        value: "", // Provide the initial value here
        info: "Organization managing the group",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1249,
        label: "member",
        placeholder: "Enter member",
        value: "", // Provide the initial value here
        info: "Search by member Patient reference",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1250,
        label: "type",
        placeholder: "Enter type",
        value: "", // Provide the initial value here
        info: "Kind of Group (person, practitioner, etc.)",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1251,
        label: "value",
        placeholder: "Enter value",
        value: "", // Provide the initial value here
        info: "Characteristic value, NPI",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],
    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  Groupid: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/Group/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/Group/{id}",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [
      {
        id: 1403,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Group id",
        infobold: "",
      },
    ],
    header: [
      {
        id: 1400,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 1402,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 1401,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "Optional UUID for request tracing",
        infobold: "",
      },
    ],
    info: [],
    queryParams: [],

    response: [
      {
        statusCode: "200",
        description: "the resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  JobStatus: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/_operations/export/{id}",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/_operations/export/{id}",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [
      {
        id: 1403,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Job id",
        infobold: "",
      },
    ],
    header: [
      {
        id: 1400,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 1402,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 1401,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "Optional UUID for request tracing",
        infobold: "",
      },
    ],
    info: [],
    queryParams: [],

    response: [
      {
        statusCode: "200",
        description: "The resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  DownloadFileAPI: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/{exported job ID}/{File Name}.ndjson",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/{exported job ID}/{File Name}.ndjson",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [],
    header: [
      {
        id: 1400,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 1602,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 1601,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "Optional UUID for request tracing",
        infobold: "",
      },
    ],
    info: [],
    queryParams: [],

    response: [
      {
        statusCode: "200",
        description: "The resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  DavinciDataExport: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/Group/{id}/$davinci-data-export",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/provideraccess/Group/{id}/$davinci-data-export",
    languageurl:
      "https://www.hl7.org/fhir/capabilitystatement.html",
    path: [
      {
        id: 1501,
        label: "id",
        placeholder: "id",
        value: "",
        info: "Group id",
        infobold: "",
      },
    ],
    header: [
      {
        id: 1502,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
      {
        id: 1504,
        label: "Authorization",
        placeholder: "Bearer {your access token}",
        value: "",
        info: "Valid access token",
        infobold: "",
      },
      {
        id: 1503,
        label: "Accept",
        placeholder: "application/json",
        value: "",
        info: "Optional UUID for request tracing",
        infobold: "",
      },
      {
        id: 1507,
        label: "Prefer",
        placeholder: "",
        value: "",
        info: "respond-async",
        infobold: "",
      },
      {
        id: 1506,
        label: "Content-Type",
        placeholder: "",
        value: "",
        info: "application/json",
        infobold: "",
      },
    ],
    info: [],
    queryParams: [
      {
        id: 1505,
        label: "exportType",
        placeholder: "Enter export type",
        value: "", // Provide the initial value here
        info: "Must be hl7.fhir.us.davinci-pdex#provider-download",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1505,
        label: "_type",
        placeholder: "Enter _type",
        value: "", // Provide the initial value here
        info: "Comma-delimited FHIR resource types (e.g. Patient,Coverage,ExplanationOfBenefit)",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1506,
        label: "_since",
        placeholder: "Enter _since",
        value: "", // Provide the initial value here
        info: "ISO 8601 datetime — export resources updated after this timestamp",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1507,
        label: "_until",
        placeholder: "Enter _until",
        value: "", // Provide the initial value here
        info: "ISO 8601 datetime — upper bound for export window",
        infobold: "",
        chains: false,
        chipsname: [],
      },
      {
        id: 1508,
        label: "_typeFilter",
        placeholder: "Enter _typeFilter",
        value: "", // Provide the initial value here
        info: "Additional FHIR search filter per resource type. Format: ResourceType?param=value",
        infobold: "",
        chains: false,
        chipsname: [],
      }
    ],

    response: [
      {
        statusCode: "202 Accepted",
        description: "The resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  CrdServices: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/coveragerequirementsdiscovery/v2/cds-services",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/coveragerequirementsdiscovery/v2/cds-services",
    languageurl:
      "http://hl7.org/fhir/us/davinci-crd/StructureDefinition/profile-coverage",
    path: [],
    header: [
      {
        id: 1601,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      },
    ],
    queryParams: [],
    response: [
      {
        statusCode: "200",
        description: "The resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "401",
        description: "Unauthorized.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  PriorAuthCheck: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/coveragerequirementsdiscovery/v2/cds-services/order-select",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/coveragerequirementsdiscovery/v2/cds-services/order-select",
    languageurl:
      "http://hl7.org/fhir/us/davinci-crd/StructureDefinition/profile-coverage",
    path: [],
    header: [
      {
        id: 1602,
        label: "payer-id",
        placeholder: "payer-id",
        value: "",
        info: "Select Payer ID",
        infobold: "",
      }
    ],
    queryParams: [],
    bodyCode: `{
  "hook": "order-select",
  "hookInstance": "e4b67d78-77d6-4a45-b9c0-2f2dd87d5b77",
  "context": {
    "userId": "Practitioner/{Provider ID}",
    "patientId": "Patient/{Patient ID}",
    "encounterId": "Encounter/{Encounter ID}",
    "selections": [
      "ServiceRequest/sr-1",
      "ServiceRequest/sr-2"
    ],
    "draftOrders": {
      "resourceType": "Bundle",
      "type": "collection",
      "entry": [
        {
          "resource": {
            "resourceType": "ServiceRequest",
            "id": "sr-1",
            "status": "draft",
            "intent": "order",
            "subject": {
              "reference": "Patient/{Patient ID}"
            },
            "encounter": {
              "reference": "Encounter/{Encounter ID}"
            },
            "requester": {
              "reference": "Practitioner/{Provider ID}"
            },
            "code": {
              "coding": [
                {
                  "system": "http://www.ama-assn.org/go/cpt",
                  "code": "{Primary Service Code}",
                  "display": "{Primary Service Description}"
                }
              ]
            }
          }
        },
        {
          "resource": {
            "resourceType": "ServiceRequest",
            "id": "sr-2",
            "status": "draft",
            "intent": "order",
            "subject": {
              "reference": "Patient/{Patient ID}"
            },
            "encounter": {
              "reference": "Encounter/{Encounter ID}"
            },
            "requester": {
              "reference": "Practitioner/{Provider ID}"
            },
            "code": {
              "coding": [
                {
                  "system": "http://www.ama-assn.org/go/cpt",
                  "code": "{Additional Service Code}",
                  "display": "{Additional Service Description}"
                }
              ]
            }
          }
        }
      ]
    }
  },
  "prefetch": {
    "patient": {
      "resourceType": "Patient",
      "id": "{Patient ID}",
      "name": [
        {
          "family": "Doe",
          "given": [
            "Jane"
          ]
        }
      ],
      "gender": "female",
      "birthDate": "1985-06-10"
    },
    "coverage": {
      "resourceType": "Coverage",
      "id": "{Coverage ID}",
      "status": "active",
      "beneficiary": {
        "reference": "Patient/{Patient ID}"
      },
      "payor": [
        {
          "reference": "Organization/{Payer Organization ID}"
        }
      ]
    }
  }
}`,
    response: [
      {
        statusCode: "200",
        description:
          "The resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "401",
        description: "Unauthorized.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  SubmitAttachment: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/clinicaldataexchange/v1/$submit-attachment",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/clinicaldataexchange/v1/$submit-attachment",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pas/StructureDefinition/profile-claim",
    path: [],
    bodyCode: `{
      { 
  "resourceType": "Parameters", 
  "parameter": [ 
    { 
      "name": "TrackingId", 
      "valueIdentifier": { 
        "system": "http://source.Aaneelconnect.com/providers", 
        "value": "11234657" 
      } 
    }, 
    { 
      "name": "AttachTo", 
      "valueCode": "claim" 
    }, 
    { 
      "name": "PayerId", 
      "valueIdentifier": { 
        "system": "http://source.aetna.com/payer-ids/identifier/commercial", 
        "value": "60054" 
      } 
    }, 
    { 
      "name": "OrganizationId", 
      "valueIdentifier": { 
        "system": "http://hl7.org/fhir/sid/us-npi", 
        "value": "1407071236" 
      } 
    }, 
    { 
      "name": "ProviderId", 
      "valueIdentifier": { 
        "system": "http://hl7.org/fhir/sid/us-npi", 
        "value": "9941339108" 
      } 
    }, 
    { 
      "name": "MemberId", 
      "valueIdentifier": { 
        "system": "https://sources.AaNeelconnect.com/member/identifier/41", 
        "value": "W819234567" 
      } 
    }, 
    { 
      "name": "ServiceDate", 
      "valueDateTime": "2022-06-16T00:00:00Z" 
    }, 
    { 
      "name": "Attachment", 
      "part": [ 
        { 
          "name": "LineItem", 
          "valueString": "1" 
        }, 
        { 
          "name": "LineItem", 
          "valueString": "2" 
        }, 
        { 
          "name": "LineItem", 
          "valueString": "3" 
        }, 
        { 
          "name": "Code", 
          "valueCodeableConcept": { 
            "coding": [ 
              { 
                "system": "http://loinc.org", 
                "code": "11504-8", 
                "display": "Surgical operation note" 
              } 
            ], 
            "text": "Surgical operation note" 
          } 
        }, 
        { 
          "name": "Content", 
          "resource": { 
            "resourceType": "DocumentReference", 
            "status": "current", 
            "type": { 
              "coding": [ 
                { 
                  "system": "http://loinc.org", 
                  "code": "11504-8", 
                  "display": "Surgical operation note" 
                } 
              ], 
              "text": "Surgical operation note" 
            }, 
            "category": [ 
              { 
                "coding": [ 
                  { 
                    "system": "http://hl7.org/fhir/us/core/CodeSystem/us-core-documentreference-category", 
                    "code": "clinical-note", 
                    "display": "Clinical Note" 
                  } 
                ], 
                "text": "Clinical Note 1" 
              } 
            ], 
            "subject": { 
              "identifier": { 
                "system": "https://sources.AaNeelconnect.com/member/identifier/41", 
                "value": "W819234567" 
              } 
            }, 
            "date": "2022-07-13T15:30:00Z", 
            "content": [ 
              { 
                "attachment": { 
                  "contentType": "text/xml", 
                  "data": "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0id2luYmRvbWVuIHdhcyB0a0aW9uLjwvcGFyYWdyYXBoPjwvdGV4dD48L3NlY3Rpb24+PC9jb21wb25lbnQ+PGNvbXBvbmVudD48c2VjdGlvbj48dGVtcGxhdGVJZCByb290PSIyLjE2Ljg0MC4xLjExMzg4My4xMC4yMC4yMi4yLjMxIiAvPjxjb2RlIGNvZGU9IjU5NzczLTIiIGNvZGVTeXN0ZW09IjIuMTYuODQwLjEuMTEzODgzLjYuMSIgY29kZVN5c3RlbU5hbWU9IkxPSU5DIiBkaXNwbGF5TmFtZT0iUHJvY2VkdXJlIFNwZWNpbWVucyBUYWtlbiIgLz48dGl0bGU+UHJvY2VkdXJlIFNwZWNpbWVucyBUYWtlbjwvdGl0bGU+PHRleHQ+PHBhcmFncmFwaD5DaGVjayBTdXJnZXJ5IERldGFpbHMgc2VjdGlvbi48L3BhcmFncmFwaD48L3RleHQ+PC9zZWN0aW9uPjwvY29tcG9uZW50Pjwvc3RydWN0dXJlZEJvZHk+PC9jb21wb25lbnQ+PC9DbGluaWNhbERvY3VtZW50Pg0K", 
                  "hash": "Am1WgpeDLm4IPpZUkEGnKqODuyM=", 
                  "title": "Example CCDA" 
                } 
              } 
            ] 
          } 
        } 
      ] 
    } 
  ] 
}`,
    header: [
      {
        id: 1612,
        label: "Authorization",
        placeholder: "Enter Authorization",
        value: "",
        info: "Valid access token",
        infobold: "",
      }
    ],
    queryParams: [],
    response: [
      {
        statusCode: "200",
        description:
          "The resource being returned.",
        dotType: "good",
      },
      {
        statusCode: "400",
        description: "Bad Request.",
        dotType: "bad",
      },
      {
        statusCode: "401",
        description: "Unauthorized.",
        dotType: "bad",
      },
      {
        statusCode: "404",
        description: "Not Found",
        dotType: "unknown",
      },
      {
        statusCode: "Default",
        description: "Error, with details",
        dotType: "unknown",
      },
    ],
  },
  ClaimSubmit: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/priorauthorizationsupport/v1/pas/Claim/$submit",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/priorauthorizationsupport/v1/pas/Claim/$submit",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pas/StructureDefinition/profile-claim",
    path: [],
    bodyCode: `{ 
   "resourceType":"Bundle", 
   "type":"collection", 
   "timestamp":"2026-06-29T10:14:58.435Z", 
   "entry":[ 
      { 
         "resource":{ 
            "resourceType":"Claim", 
            "id":"claim-order-mqz29li1-3", 
            "use":"preauthorization", 
            "status":"active", 
            "type":{ 
               "coding":[ 
                  { 
                     "system":"http://terminology.hl7.org/CodeSystem/claim-type", 
                     "code":"professional" 
                  } 
               ] 
            }, 
            "priority":{ 
               "coding":[ 
                  { 
                     "system":"http://terminology.hl7.org/CodeSystem/processpriority", 
                     "code":"normal" 
                  } 
               ] 
            }, 
            "patient":{ 
               "reference":"Patient/jane-doe-001" 
            }, 
            "provider":{ 
               "reference":"Organization/org-aaneel-001", 
               "display":"Pillpalcare Provider Group" 
            }, 
            "insurer":{ 
               "reference":"Organization/aetna", 
               "display":"Aetna" 
            }, 
            "created":"2026-06-29T10:14:58.435Z", 
            "insurance":[ 
               { 
                  "sequence":1, 
                  "focal":true, 
                  "coverage":{ 
                     "reference":"Coverage/COV-jane-doe-001" 
                  } 
               } 
            ], 
            "diagnosis":[ 
               { 
                  "sequence":1, 
                  "diagnosisCodeableConcept":{ 
                     "coding":[ 
                        { 
                           "system":"http://hl7.org/fhir/sid/icd-10-cm", 
                           "code":"M54.5", 
                           "display":"Low back pain (chronic, > 12 weeks)" 
                        } 
                     ] 
                  } 
               } 
            ], 
            "item":[ 
               { 
                  "sequence":1, 
                  "productOrService":{ 
                     "coding":[ 
                        { 
                           "system":"http://www.ama-assn.org/go/cpt", 
                           "code":"72148", 
                           "display":"MRI Lumbar Spine (without contrast)" 
                        } 
                     ] 
                  }, 
                  "quantity":{ 
                     "value":1 
                  }, 
                  "servicedPeriod":{ 
                     "start":"2026-06-29", 
                     "end":"2026-09-27" 
                  } 
               } 
            ] 
         } 
      }, 
      { 
         "resource":{ 
            "resourceType":"Patient", 
            "id":"jane-doe-001", 
            "identifier":[ 
               { 
                  "system":"urn:aaneel:patient-mrn", 
                  "value":"MRN-87412", 
                  "type":{ 
                     "coding":[ 
                        { 
                           "system":"http://terminology.hl7.org/CodeSystem/v2-0203", 
                           "code":"MR", 
                           "display":"Medical record number" 
                        } 
                     ] 
                  } 
               } 
            ], 
            "name":[ 
               { 
                  "family":"Doe", 
                  "given":[ 
                     "Jane" 
                  ] 
               } 
            ], 
            "birthDate":"1978-04-12", 
            "gender":"female" 
         } 
      }, 
      { 
         "resource":{ 
            "resourceType":"Coverage", 
            "id":"COV-jane-doe-001", 
            "status":"active", 
            "subscriberId":"W123456789", 
            "beneficiary":{ 
               "reference":"Patient/jane-doe-001" 
            }, 
            "payor":[ 
               { 
                  "reference":"Organization/aetna", 
                  "display":"Aetna" 
               } 
            ], 
            "class":[ 
               { 
                  "type":{ 
                     "coding":[ 
                        { 
                           "system":"http://terminology.hl7.org/CodeSystem/coverage-class", 
                           "code":"plan", 
                           "display":"Plan" 
                        } 
                     ] 
                  }, 
                  "value":"AETNA-PPO-GOLD", 
                  "name":"Aetna PPO Gold" 
               } 
            ], 
            "period":{ 
               "start":"2026-01-01", 
               "end":"2026-12-31" 
            } 
         } 
      }, 
      { 
         "resource":{ 
            "resourceType":"Practitioner", 
            "id":"practitioner-admin", 
            "identifier":[ 
               { 
                  "system":"http://hl7.org/fhir/sid/us-npi", 
                  "value":"1112223334" 
               } 
            ], 
            "name":[ 
               { 
                  "given":[ 
                     "Admin" 
                  ], 
                  "family":"User" 
               } 
            ] 
         } 
      }, 
      { 
         "resource":{ 
            "resourceType":"Organization", 
            "id":"org-aaneel-001", 
            "name":"Pillpalcare Provider Group", 
            "identifier":[ 
               { 
                  "system":"http://hl7.org/fhir/sid/us-npi", 
                  "value":"1234567890" 
               } 
            ], 
            "telecom":[ 
               { 
                  "system":"phone", 
                  "value":"617-555-0100" 
               } 
            ], 
            "address":[ 
               { 
                  "line":[ 
                     "1200 Boylston St" 
                  ], 
                  "city":"Boston", 
                  "state":"MA", 
                  "postalCode":"02215" 
               } 
            ] 
         } 
      }, 
      { 
         "resource":{ 
            "resourceType":"QuestionnaireResponse", 
            "id":"qr-1d29922ebd164992ac34f1708d6fcdf1", 
            "status":"completed", 
            "questionnaire":"q-mri-lumbar", 
            "subject":{ 
               "reference":"Patient/jane-doe-001" 
            }, 
            "authored":"2026-06-29T10:14:51.596Z" 
         } 
      } 
   ] 
}`,
    header: [
      {
        id: 1612,
        label: "Authorization",
        placeholder: "Enter Authorization",
        value: "",
        info: "Valid access token",
        infobold: "",
      }
    ],
    queryParams: [],
    response: [
      {
        statusCode: "200",
        description:
          "The resource being returned.",
        dotType: "good",
      }
    ],
  },
  ClaimResponse: {
    url: "https://api-sandbox.aaneelconnect.com/cms/r4/priorauthorizationsupport/v1/pas/ClaimResponse/claim-order-mqz29li1-3",
    codeurl:
      "https://api-sandbox.aaneelconnect.com/cms/r4/priorauthorizationsupport/v1/pas/ClaimResponse/claim-order-mqz29li1-3",
    languageurl:
      "http://hl7.org/fhir/us/davinci-pas/StructureDefinition/profile-claim",
    path: [],
    header: [],
    queryParams: [
      {
        id: 1613,
        label: "id",
        placeholder: "Enter Id",
        value: "",
        info: "Auth Tracking number.",
        infobold: "",
        chains: false,
        chipsname: [],
      },
    ],
    response: [
      {
        statusCode: "200",
        description:
          "The resource being returned.",
        dotType: "good",
      }
    ],
  },
};


export const API_DESCRIPTION: ApiDescriptionProps[] = [
  {
    id: "Endpoint",
    description: `Provide technical details related to endpoints that are used for electronic services. <br /> <br/>
    The Endpoint API returns fields including extension, status, connection type, name, contact, payload type, payload MIME type, and address (URL).`,
    header: "Plan Net Endpoint",
    path: "/providerdirectory/endpoint-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Endpoint",
  },
  {
    id: "Healthcare",
    description: `Plan Net Healthcare Service API covers data related to a healthcare service and services provided by an organization at a specific location. <br /> <br/>
    The healthcare service resource typically describes services offered by an organization/practitioner at a location. The resource may be used to encompass a variety of services covering the entire healthcare spectrum, including promotion, prevention, diagnostics, hospital and ambulatory care, home care, long-term care, and other health-related and community services.`,
    header: "Plan Net Healthcare Service",
    path: "/providerdirectory/healthcareService-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-HealthcareService",
  },
  {
    id: "Insurance",
    description: `An insurance plan provides health insurance coverage benefits that are offered under a network type. <br /> <br/>
    The Insurance Plan API offers a health insurance list comprised of covered benefits (product), plan, administered by, coverage area, contact information, etc.`,
    header: "Plan Net Insurance Plan",
    path: "/providerdirectory/insuranceplan-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-InsurancePlan",
  },
  {
    id: "Location",
    description: `Plan Net Location API provides detailed position/location information of the physical place that is associated with a patient, provider, or organization. Location may include private, public, mobile, or fixed. Location examples are buildings, wards, rooms, mobile clinics, vehicles, parking places, ambulances, etc. <br /> <br/>
    Plan Net Location API return fields, including status (active, suspended, inactive), name, telecom, address, and managing organization (organization responsible).`,
    header: "Plan Net Location",
    path: "/providerdirectory/location-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Location",
  },
  {
    id: "Organization",
    description: `The organization resource describes a grouping of people or business entities relevant to the healthcare process. Organizations include hospitals, employers, insurance companies, physicians’ offices, rehabilitation facilities, laboratories, etc.
    <br /> <br/>
    The Plan Net Organization API returns fields including Organization Identifier, Active (whether the organization is active), Type (type of organization), name, contact information, and address.`,
    header: "Plan Net Organization",
    path: "/providerdirectory/organization-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Organization",
  },
  {
    id: "OrganizationAffiliation",
    description: `Organization Affiliation defines a relation between two separate business entities. <br /> <br/>
    Plan Net Organization Affiliation API returns fields including Organization, Participating organization, Period, active (organization affiliation record is in active use), Network and location.`,
    header: "Plan Net Organization Affiliation",
    path: "/providerdirectory/organizationaffiliation-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-OrganizationAffiliation",
  },
  {
    id: "Practitioner",
    description: `The Plan Net Practitioner API provides information about a person formally involved in the healthcare process and healthcare-related services on behalf of a healthcare facility. Practitioners include, and are not limited to, physicians, nurses, pharmacists, therapists, technologists, and social workers.
    <br /> <br/>
    The Plan Net Practitioner API returns fields including Practitioner ID, NPI, name, address, and profile information.`,
    header: "Plan Net Practitioner",
    path: "/providerdirectory/practitioner-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-Practitioner",
  },
  {
    id: "PractitionerRole",
    description: `The Plan Net Practitioner Role API covers data related to the type of services that a practitioner provides for an organization. The Plan Net Practitioner Role API returns fields including Practitioner, Organization (organization where the roles are available), code (role of the practitioner), specialty (specialty of the practitioner), location (the location(s) at which this practitioner provides care), and telecom (contact details).`,
    header: "Plan Net Practitioner Role",
    path: "/providerdirectory/practitionerrole-api",
    url: "http://hl7.org/fhir/us/davinci-pdex-plan-net/StructureDefinition/plannet-PractitionerRole",
  },
  {
    id: "List",
    description: `The manager for resources of type CoveragePlan provides services to manage the collection of all the CoveragePlan instances.`,
    header: "Coverage Plan",
    path: "/formulary/list-api",
    url: "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
  },
  {
    id: "Substance",
    description: `Medication(s) or substance(s) contained in the medication.`,
    header: "Formulary Substance API",
    path: "/formulary/substance-api",
    url: "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
  },
  {
    id: "MedicationKnowledge",
    description: `The manager for resources of type FormularyDrug provides services to manage the collection of all the FormularyDrug instances.`,
    header: "Formulary Drug",
    path: "/formulary/medicationknowledge-api",
    url: "https://hl7.org/fhir/us/davinci-drug-formulary/STU2.0.1",
  },
  {
    id: "AllergyIntolerance",
    description: `The Allergy Intolerance resource provides the clinical assessment of a patient’s allergy or intolerance when exposed to a specific substance or class of substances, including information about the adverse reaction. <br/><br/>
    The Allergy Intolerance API returns data fields including clinicalStatus , verificationStatus, code (code for an allergy or intolerance statement), patient, reactions (clinical symptoms and/or signs observed), and DateTime (when the allergy/intolerance was identified).`,
    header: "Allergy Intolerance",
    path: "/patientAccess/allergyIntolerance-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-allergyintolerance|6.1.0",
  },
  {
    id: "CarePlan",
    description: `The Care Plan API describes the intentions of how one or more practitioners plan to deliver care to a specific patient. Care plans are used in a variety of areas and scopes, ranging from encounter- or visit-specific to cross-visits. Care plans are used to group activities, goals, and/or practitioners to create context. Care plans are intended to be specific to the patient. It is possible for a planned activity to stand alone without a care plan, such as a scheduled appointment <br/><br/>
    The Care Plan API covers data like ID, subject (patient), status, care plan, category (assess-plan), encounter, and period (time period plan covers).`,
    header: "Care Plan",
    path: "/patientAccess/carePlan-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-careplan|6.1.0",
  },
  {
    id: "CareTeam",
    description: `Care Team are the team people who participate in the delivery of care for a patient. <br/><br/>
    The Care Team API covers data like ID, subject (patient), status, category (care team category), managing organization (organization responsible for the care team), etc.`,
    header: "Care Team",
    path: "/patientAccess/careTeam-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-careteam|6.1.0",
  },
  {
    id: "Condition",
    description: `The Condition resource is used to record details about a patient’s problems, diagnoses, or other health matters that are concerning. It is common to capture conditions during the encounter or visit. <br/><br/>
    The Condition API returns fields including category (assigned category to the condition), code (identification of the condition, problem, or diagnosis), clinical status (the clinical status of the condition), verification status (verification status to support clinical status of the condition), and subject (person who has the condition).`,
    header: "Condition",
    path: "/patientAccess/condition-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition-problems-health-concerns|6.1.0",
  },
  {
    id: "Coverage",
    description: `Data that reflect a payer’s coverage that was effective as of the date of service or the date of admission of the claim. (*Based on the HL7 FHIR implementation guide found at https://build.fhir.org/ig/HL7/carin-bb/artifacts.html#3).`,
    header: "C4BB Coverage",
    path: "/patientAccess/coverage-api",
    url: "http://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-Coverage|2.0.0",
  },
  {
    id: "ExplanationOfBenefit",
    description: `The Explanation Of Benefit (EOB) resource combines key information from a claim, a claim response, and optional account information to inform a patient of the goods and services rendered by a provider and the settlement made under the patient's coverage in respect of that claim. <br/><br/>
    The Explanation of Benefit resource may also be used as a resource for data exchange for bulk data analysis, as the resource encompasses claim, claim response, and coverage/eligibility information. <br/><br/>
   Abstract parent profile that includes constraints that are common to the four specific ExplanationOfBenefit (EOB) profiles defined in this Implementation Guide. All EOB instances should be from one of the four concrete EOB profiles defined in this Implementation Guide: Inpatient, Outpatient, Pharmacy, and Professional/NonClinician. (*Based on the HL7 FHIR implementation guide found at https://build.fhir.org/ig/HL7/carin-bb/artifacts.html#3)`,
    header: "C4BB Explanation Of Benefit",
    path: "/patientAccess/explanationOfBenefit-api",
    url: `http://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-ExplanationOfBenefit-Inpatient-Institutional|2.0.0
http://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-ExplanationOfBenefit-Outpatient-Institutional|2.0.0
http://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-ExplanationOfBenefit-Pharmacy|2.0.0
http://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-ExplanationOfBenefit-Professional-NonClinician|2.0.0`,
  },
  {
    id: "Goal",
    description: `A Goal resource is typically expressed as a desired outcome or health state to be achieved by a patient over a period or at a specific point in time. A Goal may address preventative health or mitigation of a diagnosis or problem. <br/><br/>
    The Goal API returns data including lifecycle status (the state of the Goal), description (Goal description, e.g., control blood pressure, daily exercise, etc.), subject (patient), target (what should be done by when), and due date (date/duration the goal should be met).`,
    header: "Goal",
    path: "/patientAccess/goal-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-goal|6.1.0",
  },
  {
    id: "Immunization",
    description: `The Immunization API includes the view of current and historical administration of vaccinations to a patient in all healthcare settings. This API contains the functionality to query a patient’s immunization history. <br/><br/>
    Detailed administration records may be found in MedicationAdministration, while the Immunization API would represent the known vaccination history regardless of where the administration itself was done. <br/><br/>
    The Immunization API returns fields including status, status reason, vaccine code, patient, encounter, occurrence, primary source, manufacturer, lot number, expiration date, dose quantity, performer, and note.`,
    header: "Immunization",
    path: "/patientAccess/immunization-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-immunization|6.1.0",
  },
  {
    id: "MedicationRequest",
    description: `The Medication Request API covers data related to all provider-prescribed, inpatient, outpatient-administered, and patient self-prescribed medication lists. <br/><br/>
    The Medication Request API provides orders for all medications along with administration instructions for a patient in both the inpatient and outpatient settings (orders/prescriptions filled by a pharmacy and discharge medication orders).<br/><br/>
The Medication Request API returns fields including status, intent, reported medication, subject (patient), encounter, authored on (when the request was authored), requester, and dosage instruction (how medication should be taken).`,
    header: "Medication Request",
    path: "/patientAccess/medicationRequest-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-medicationrequest|6.1.0",
  },
  {
    id: "Observation",
    description: `Laboratory Result Observation API covers data related to patient lab results. <br/><br/>
    API covers data like Status, Code (Lab report code), Subject(Patient), results and Effective Date and time.`,
    header: "Observation",
    path: "/patientAccess/observation-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-observation-lab|6.1.0",
  },
  {
    id: "Patient",
    description: `The Patient API provides general demographic information about a person receiving health care services from a specific organization. <br/><br/>
    Patient API covers the patient's demographic data that is used to support financial, administrative, and logistic procedures. Patient records are created and maintained by the organization that is providing care.
     <br/><br/>
    The Patients API returns patients data, including family name, given name, address, date of birth, gender, and telecom.`,
    header: "Patient",
    path: "/patientAccess/patient-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-patient|6.1.0",
  },
  {
    id: "Procedure",
    description: `The Procedure API describes the request or order for a procedure or activity performed with or on a patient. This resource includes a wide range of requests, including surgery procedures, diagnostic procedures, therapies, patient care activities, referrals, and consults. This resource does NOT include medication, dietary, and appointment requests. <br/><br/>
    The Procedure API returns fields including status, code, subject, encounter, and performed.`,
    header: "Procedure",
    path: "/patientAccess/procedure-api",
    url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-procedure|6.1.0",
  },
  {
    id: "Group",
    description: `This Group End point explain to a provider how to use this endpoint to find the FHIR Group resource(s) containing their attributed members, which is required before initiating a bulk data export.  <br/><br/>
    Groups conform to the PDexMemberMatchGroup profile and are identified by provider NPI.`,
    header: "Group",
    path: "/provideracess/group-api",
    url: "https://build.fhir.org/ig/HL7/davinci-epdx/provider-access-api.html",
  },
  {
    id: "JobStatus",
    description: `This API explain that once a bulk export job completes, the 200 OK manifest from $exportstatus contains a list of NDJSON file URLs. <br/><br/>
     Each URL must be downloaded individually using a valid Bearer token.`,
    header: "Group Export",
    path: "/provideracess/group-export",
    url: "https://build.fhir.org/ig/HL7/davinci-epdx/provider-access-api.html",
  },
  {
    id: "DownloadFileAPI",
    description: `This API explain that once a bulk export job completes, the 200 OK manifest from $exportstatus contains a list of NDJSON file URLs. <br/><br/>
     Each URL must be downloaded individually using a valid Bearer token.`,
    header: "Group Export",
    path: "/provideracess/group-export",
    url: "https://build.fhir.org/ig/HL7/davinci-epdx/provider-access-api.html",
  },
  {
    id: "CrdServices",
    description: `The CRD Services API returns the list of CDS Hooks services supported by the payer for Coverage Requirements Discovery. <br/><br/>
    Providers call this GET endpoint to discover available CRD hooks before invoking a specific service such as order-select.`,
    header: "CRD Services",
    path: "/crd/cds-services",
    url: "http://hl7.org/fhir/us/davinci-crd/StructureDefinition/profile-coverage",
  },
  {
    id: "PriorAuthCheck",
    description: `The Prior Auth Check API lets providers verify, in real time, whether a proposed service requires prior authorization and what documentation the payer needs to make a determination. <br/><br/>
    The endpoint accepts a JSON payload describing the patient, coverage, provider, and requested service, and returns the coverage determination along with any documentation requirements.`,
    header: "CRD Prior Auth Check",
    path: "/crd/prior-auth-check",
    url: "http://hl7.org/fhir/us/davinci-crd/StructureDefinition/profile-coverage",
  },
  {
    id: "DTR",
    description: `Once CRD confirms that authorization is required, DTR (Documentation Templates and Rules) launches automatically — either as a SMART on FHIR application or natively inside the EHR. DTR retrieves a payer-specific questionnaire and uses CQL (Clinical Quality Language) logic to auto-populate fields with data already present in the patient's record. <br/><br/>
    The provider only needs to complete the fields that cannot be automatically populated. This dramatically reduces the documentation burden and eliminates errors from manual data entry. <br/><br/>
    DTR uses the $questionnaire-package FHIR operation to retrieve questionnaires and supports: <br/><br/>
    <ul class="m-0! list-disc! pl-5! text-sm marker:text-(--moderatevioletcustom)">
    <li class="list-item!">Standard questionnaires for straightforward, routine authorization scenarios</li>
    <li class="list-item!">Adaptive questionnaires via $next-question — for complex clinical scenarios where the questions adapt dynamically based on previous answers</li>
    </ul>`,
    header: "DTR API",
    path: "/dtr",
    url: "http://hl7.org/fhir/us/davinci-dtr/",
  },
];
